import React from "react";
import PropTypes from "prop-types";
import { BASE_IMAGE_API_URL } from "../../services/baseServices";

export default function ViewProduct({viewObj}) {

    return (
        <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasRightView"
            aria-labelledby="offcanvasRightLabel"
            style={{ minWidth: "45%", maxWidth: "45%" }}
        >
            <form autoComplete="off">
                <div className="offcanvas-header d-flex justify-content-between align-items-center">
                    <h5 id="offcanvasRightLabel" className="mb-0">View Product</h5>
                    <div className="d-flex align-items-center">
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                </div>
                <div 
                    className="offcanvas-body" 
                    style={{
                        minHeight: '33rem',
                        overflowY: 'auto',
                        paddingBottom: '2rem',
                    }}
                >
                    <div className="row">
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Name <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"   
                                value={viewObj?.ProductName}
                                readOnly                         
                            />
                        </div>
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Code <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                value={viewObj?.ProductCode}
                                readOnly 
                            />
                        </div>
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Brand <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                value={viewObj?.Brand}
                                readOnly 
                            />
                        </div>
                        <div className="" style={{ flex: 1 }}>
                            <label className="form-label">Category <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                value={viewObj?.CategoryName}
                                readOnly 
                            />
                        </div>
                       
                        <div className="col-12 mb-2">
                            <label className="form-label">Description <span className="text-danger">*</span></label>
                            <div
                                className="description-content"
                                dangerouslySetInnerHTML={{ __html: viewObj?.Description }}
                            />
                        </div>
                    </div>
                <div className="col-12 mb-3">
                    <label className="form-label">Product Image</label>
                    <div
                        style={{
                            width: '100%',
                            maxWidth: '350px',
                            height: 'auto',
                            marginTop: '0.5rem',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            border: '1px solid #ddd',
                        }}
                    >
                        <img
                            src={`${BASE_IMAGE_API_URL}${viewObj?.ImageUrl}`}
                            alt={viewObj?.ProductName || 'Product Image'}
                            style={{ width: '100%', height: 'auto', display: 'block' }}
                        />
                    </div>
                </div>
                </div>
            </form>

        </div>
    );
}


ViewProduct.propTypes = {
    viewObj: PropTypes.object.isRequired,
};

